/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../paymentactivator/deactivations';
import '../common/time';
import '../ledger/freezes';
import '../identityverifier/model/verification';
import '../secure_profile/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "riskprofiler": {
        "nested": {
          "service": {
            "nested": {
              "DeactivationEntity": {
                "fields": {
                  "actorId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "serviceName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "comment": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "actorToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.paymentactivator.DeactivationType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "stateChange": {
                    "type": ".squareup.paymentactivator.DeactivationState",
                    "id": 6,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "FreezeEntity": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.ledger.service.FreezeType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "IdentityVerificationEntity": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "application": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clientKey": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "productIntent": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "userFormUrl": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 10,
                    "rule": "optional"
                  },
                  "completedStatus": {
                    "type": ".squareup.riskprofiler.service.IdentityVerificationEntity.CompletedStatus",
                    "id": 3
                  },
                  "erroredStatus": {
                    "type": ".squareup.riskprofiler.service.IdentityVerificationEntity.ErroredStatus",
                    "id": 4
                  },
                  "inProgressStatus": {
                    "type": ".squareup.riskprofiler.service.IdentityVerificationEntity.InProgressStatus",
                    "id": 5
                  },
                  "createdStatus": {
                    "type": ".squareup.riskprofiler.service.IdentityVerificationEntity.CreatedStatus",
                    "id": 8
                  }
                },
                "nested": {
                  "Decision": {
                    "fields": {
                      "verified": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CompletedStatus": {
                    "fields": {
                      "decision": {
                        "type": ".squareup.riskprofiler.service.IdentityVerificationEntity.Decision",
                        "id": 1,
                        "rule": "optional"
                      },
                      "correctedDataAvailable": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ErroredStatus": {
                    "fields": {
                      "errorCause": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "InProgressStatus": {
                    "fields": {
                      "interactiveSessionStatus": {
                        "type": ".squareup.identityverifier.model.InteractiveUserSession.SessionStatus",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CreatedStatus": {
                    "fields": {}
                  },
                  "status": {
                    "oneof": ["completedStatus", "erroredStatus", "inProgressStatus", "createdStatus"]
                  }
                }
              },
              "SspEntity": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "state": {
                    "type": ".squareup.secure_profile.common.RequestState",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.secure_profile.common.RequestType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "previouslyReviewed": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  },
                  "active": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "RiskProfileUnit": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "nickname": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "freezes": {
                    "type": ".squareup.riskprofiler.service.FreezeEntity",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "ssps": {
                    "type": ".squareup.riskprofiler.service.SspEntity",
                    "id": 6,
                    "rule": "repeated"
                  },
                  "deactivations": {
                    "type": ".squareup.riskprofiler.service.DeactivationEntity",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "identityVerifications": {
                    "type": ".squareup.riskprofiler.service.IdentityVerificationEntity",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "RiskProfileMerchant": {
                "fields": {
                  "riskProfileUnit": {
                    "type": ".squareup.riskprofiler.service.RiskProfileUnit",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetRiskProfileMerchantRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetRiskProfileMerchantResponse": {
                "fields": {
                  "riskProfileMerchant": {
                    "type": ".squareup.riskprofiler.service.RiskProfileMerchant",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "GetRiskProfileUnitRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "merchantToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetRiskProfileUnitResponse": {
                "fields": {
                  "riskProfileUnit": {
                    "type": ".squareup.riskprofiler.service.RiskProfileUnit",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "RiskProfilerService": {
                "methods": {
                  "GetRiskProfileMerchant": {
                    "requestType": ".squareup.riskprofiler.service.GetRiskProfileMerchantRequest",
                    "responseType": ".squareup.riskprofiler.service.GetRiskProfileMerchantResponse"
                  },
                  "GetRiskProfileUnit": {
                    "requestType": ".squareup.riskprofiler.service.GetRiskProfileUnitRequest",
                    "responseType": ".squareup.riskprofiler.service.GetRiskProfileUnitResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.DeactivationEntity && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.FreezeEntity && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.IdentityVerificationEntity && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.IdentityVerificationEntity?.nested?.Decision && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.IdentityVerificationEntity?.nested?.CompletedStatus && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.IdentityVerificationEntity?.nested?.ErroredStatus && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.IdentityVerificationEntity?.nested?.InProgressStatus && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.IdentityVerificationEntity?.nested?.CreatedStatus && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.SspEntity && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.RiskProfileUnit && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.RiskProfileMerchant && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.GetRiskProfileMerchantRequest && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.GetRiskProfileMerchantResponse && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.GetRiskProfileUnitRequest && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.GetRiskProfileUnitResponse && !$root.nested?.squareup?.nested?.riskprofiler?.nested?.service?.nested?.RiskProfilerService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeactivationEntity @ squareup/riskprofiler/service.proto at 18:1
 */
export const DeactivationEntity = $root.lookupType('squareup.riskprofiler.service.DeactivationEntity');
fixType(DeactivationEntity, {
  actorId: {
    notEmpty: true
  },
  serviceName: {
    notEmpty: true
  },
  comment: {
    notEmpty: true
  },
  actorToken: {
    notEmpty: true
  },
  type: {
    required: true
  },
  stateChange: {
    required: true
  },
  createdAt: {
    required: true
  },
  active: {
    required: true
  }
});
Builder.createAndAttachToType(DeactivationEntity);
/**
 * SOURCE FreezeEntity @ squareup/riskprofiler/service.proto at 29:1
 */
export const FreezeEntity = $root.lookupType('squareup.riskprofiler.service.FreezeEntity');
fixType(FreezeEntity, {
  token: {
    notEmpty: true
  },
  type: {
    required: true
  },
  createdAt: {
    required: true
  },
  active: {
    required: true
  }
});
Builder.createAndAttachToType(FreezeEntity);
/**
 * Represents the identity verification status.
 *
 * SOURCE IdentityVerificationEntity @ squareup/riskprofiler/service.proto at 37:1
 */
export const IdentityVerificationEntity = $root.lookupType('squareup.riskprofiler.service.IdentityVerificationEntity');
fixType(IdentityVerificationEntity, {
  id: {
    notEmpty: true
  },
  application: {
    notEmpty: true
  },
  clientKey: {
    notEmpty: true
  },
  productIntent: {
    notEmpty: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(IdentityVerificationEntity);
/**
 * A final decision for a successfully completed verification.
 *
 * SOURCE Decision @ squareup/riskprofiler/service.proto at 75:3
 */
IdentityVerificationEntity.Decision = $root.lookupType('squareup.riskprofiler.service.IdentityVerificationEntity.Decision');
fixType(IdentityVerificationEntity.Decision, {
  verified: {
    required: true
  },
  comment: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(IdentityVerificationEntity.Decision);
/**
 * Represents the final state of verifications that are able to reach a final decision.
 *
 * SOURCE CompletedStatus @ squareup/riskprofiler/service.proto at 84:3
 */
IdentityVerificationEntity.CompletedStatus = $root.lookupType('squareup.riskprofiler.service.IdentityVerificationEntity.CompletedStatus');
fixType(IdentityVerificationEntity.CompletedStatus, {
  decision: {
    required: true
  },
  correctedDataAvailable: {
    required: true
  }
});
Builder.createAndAttachToType(IdentityVerificationEntity.CompletedStatus);
/**
 * Represents the final state of verifications that are unable to complete.
 *
 * SOURCE ErroredStatus @ squareup/riskprofiler/service.proto at 93:3
 */
IdentityVerificationEntity.ErroredStatus = $root.lookupType('squareup.riskprofiler.service.IdentityVerificationEntity.ErroredStatus');
fixType(IdentityVerificationEntity.ErroredStatus, {
  errorCause: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(IdentityVerificationEntity.ErroredStatus);
/**
 * Represents the state of verifications that are in progress.
 *
 * SOURCE InProgressStatus @ squareup/riskprofiler/service.proto at 99:3
 */
IdentityVerificationEntity.InProgressStatus = $root.lookupType('squareup.riskprofiler.service.IdentityVerificationEntity.InProgressStatus');
fixType(IdentityVerificationEntity.InProgressStatus);
Builder.createAndAttachToType(IdentityVerificationEntity.InProgressStatus);
/**
 * Represents the state of verifications that are created.
 *
 * SOURCE CreatedStatus @ squareup/riskprofiler/service.proto at 105:3
 */
IdentityVerificationEntity.CreatedStatus = $root.lookupType('squareup.riskprofiler.service.IdentityVerificationEntity.CreatedStatus');
fixType(IdentityVerificationEntity.CreatedStatus);
Builder.createAndAttachToType(IdentityVerificationEntity.CreatedStatus);
/**
 * SOURCE SspEntity @ squareup/riskprofiler/service.proto at 108:1
 */
export const SspEntity = $root.lookupType('squareup.riskprofiler.service.SspEntity');
fixType(SspEntity, {
  token: {
    notEmpty: true
  },
  state: {
    required: true
  },
  type: {
    required: true
  },
  updatedAt: {
    required: true
  },
  previouslyReviewed: {
    required: true
  },
  active: {
    required: true
  }
});
Builder.createAndAttachToType(SspEntity);
/**
 * SOURCE RiskProfileUnit @ squareup/riskprofiler/service.proto at 117:1
 */
export const RiskProfileUnit = $root.lookupType('squareup.riskprofiler.service.RiskProfileUnit');
fixType(RiskProfileUnit, {
  merchantToken: {
    notEmpty: true
  },
  unitToken: {
    notEmpty: true
  },
  nickname: {
    required: true
  },
  updatedAt: {
    required: true
  }
});
Builder.createAndAttachToType(RiskProfileUnit);
/**
 * SOURCE RiskProfileMerchant @ squareup/riskprofiler/service.proto at 128:1
 */
export const RiskProfileMerchant = $root.lookupType('squareup.riskprofiler.service.RiskProfileMerchant');
fixType(RiskProfileMerchant);
Builder.createAndAttachToType(RiskProfileMerchant);
/**
 * SOURCE GetRiskProfileMerchantRequest @ squareup/riskprofiler/service.proto at 218:1
 */
export const GetRiskProfileMerchantRequest = $root.lookupType('squareup.riskprofiler.service.GetRiskProfileMerchantRequest');
fixType(GetRiskProfileMerchantRequest, {
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetRiskProfileMerchantRequest);
/**
 * SOURCE GetRiskProfileMerchantResponse @ squareup/riskprofiler/service.proto at 222:1
 */
export const GetRiskProfileMerchantResponse = $root.lookupType('squareup.riskprofiler.service.GetRiskProfileMerchantResponse');
fixType(GetRiskProfileMerchantResponse, {
  riskProfileMerchant: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetRiskProfileMerchantResponse);
/**
 * SOURCE GetRiskProfileUnitRequest @ squareup/riskprofiler/service.proto at 226:1
 */
export const GetRiskProfileUnitRequest = $root.lookupType('squareup.riskprofiler.service.GetRiskProfileUnitRequest');
fixType(GetRiskProfileUnitRequest, {
  unitToken: {
    notEmpty: true
  },
  merchantToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetRiskProfileUnitRequest);
/**
 * SOURCE GetRiskProfileUnitResponse @ squareup/riskprofiler/service.proto at 231:1
 */
export const GetRiskProfileUnitResponse = $root.lookupType('squareup.riskprofiler.service.GetRiskProfileUnitResponse');
fixType(GetRiskProfileUnitResponse, {
  riskProfileUnit: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(GetRiskProfileUnitResponse);
/**
 * SOURCE RiskProfilerService @ squareup/riskprofiler/service.proto at 235:1
 */
export const RiskProfilerService = $root.lookupService('squareup.riskprofiler.service.RiskProfilerService');